/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

import Image from '../../../common/Image';
import { isEmpty } from '../../../utils/object';
import { formatPrice } from '../../../utils/formater';

class ProductDetails extends React.Component {
    productDetail = (
        key,
        {
            productName, prdImgTmn: productImage, productSku, quantity, price,
        },
        isPassport,
        isLastItem,
    ) => (
        <div
            key={key}
            className={`split product-detail margin-bottom ${
                isLastItem ? 'last' : ''
            }`}
        >
            <div className="product-image">
                <Image src={productImage} alt="" />
            </div>
            <div className="product-description">
                <div className="product-name">{productName}</div>
                <div className="split align-bottom">
                    <div className="gray-color">Item #: {productSku}</div>
                    <div className={isPassport ? 'flex-none padding-top' : 'flex-none'}>
                        <div>
                            <span className="bold -price-label">Price: </span>$
                            {formatPrice(price)}
                        </div>
                        <div className={isPassport ? 'display-none' : ''}>
                            <span className="bold -price-label">Qty: </span>
                            {quantity}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    render() {
        const { itemDetailList, isPassport } = this.props;
        // console.log('itemDetailList', itemDetailList);
        if (isEmpty(itemDetailList)) return null;
        return itemDetailList.map((product, key) => this.productDetail(
            key,
            product,
            isPassport,
            itemDetailList.length - 1 === key,
        ));
    }
}

ProductDetails.defaultProps = {
    itemDetailList: [],
    isPassport: false,
};

ProductDetails.propTypes = {
    itemDetailList: PropTypes.array,
    isPassport: PropTypes.bool,
};

export default ProductDetails;
